import React from "react";
import Card from "@material-ui/core/Card";
import { Button, CardActionArea } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import { useWallet } from '../../context/walletProvider'
import { Link } from 'react-router-dom'
function TokenCard({ header, imageUrl, message, nonce, fxnAddress, buttonMessage }) {
  const wallet = useWallet()
  return (
    <div>
      <Card
        style={{
          backgroundColor: "#0E0E0E",
          padding: "10px",
          borderRadius: "10px",
          alignItems: "center",
          width: "200px",
          margin: "10px 0px",
        }}
      >
        <CardContent style={{ textAlign: "center", padding: "0px" }}>
          <img
            style={{ height:"200px",width:"200px",borderRadius: "10px", marginBottom: "10px" }}
            src={imageUrl}
            alt='card-images'
          />
          <Typography
            style={{ fontSize: "12px", color: "#CDCDCD", textAlign: "center" }}
            gutterBottom
            variant='h5'
            component='h2'
          >
            #{header}
          </Typography>
          <Typography
            style={{
              fontSize: "10px",
              color: "#CDCDCD",
              textAlign: "center",
              marginBottom: "10px",
            }}
            variant='body2'
            color='textSecondary'
            component='p'
          >
            {message}
          </Typography>
        </CardContent>
        <CardActionArea style={{ textAlign: "center" }}>
          <Link to={`/trade/${nonce}/${fxnAddress}`} style={{textDecoration:'none'}}>
          <Button
            style={{
              borderRadius: "15px",
              fontSize: "0.7em",
              fontWeight: "700",
              letterSpacing: "2px",
              marginBottom: "10px",
              boxShadow: "0px 9px 14px rgba(255, 255, 255, 0.2)",
            }}
            variant='contained'
            size='medium'
          >
            {buttonMessage}
          </Button>
          </Link>
        </CardActionArea>
      </Card>
    </div>
  );
}

export default TokenCard;
